import RootService from './RootService'

class ApiHelper extends RootService {
  getGeoJson = async (id) => await this.api.get(`building/get_3d_model_by_id/${id}`)
    .then(response => response)

  getBuilding = async (id) => await this.api.get('building')
    .then(response => response)

  getUnit = async (id) => await this.api.get(`unit/${id}`)
    .then(response => response)

  getUnits = async (params) => await this.api.get('unit/with_details', { params })
    .then(response => response)

  getUnitWithDetails = async (id) => await this.api.get(`unit/with_details/${id}`)
    .then(response => response)
}

export default ApiHelper
